import environment from 'util/environment';


const DB_CONFIG = {
    apiKey: environment.REACT_APP_FIREBASE_API_KEY,
    authDomain: environment.REACT_APP_FIREBASE_AUTH_DOMAIN,
    databaseURL: environment.REACT_APP_FIREBASE_DATABASE_URL,
    projectId: environment.REACT_APP_FIREBASE_PROJECT_ID,
    storageBucket: environment.REACT_APP_FIREBASE_STORAGE_BUCKET,
    messagingSenderId: environment.REACT_APP_FIREBASE_MESSAGING_ID
}

export default DB_CONFIG;